import { DatePipe } from "@angular/common";
import { BaseColumnInterface } from "@shared/library/configs/interfaces/base-column-interface";
import { BaseItemEnum } from "@shared/library/configs/enums/base-item-enum";
import { PipeEnum } from "@shared/library/configs/enums/base-pipe-enum";

export class BaseCustomizeUtilities {
    /* Grids */
    static setItemsTheadBaseId(): BaseColumnInterface[] {
        return [
            { title: '#', field: 'id', type: BaseItemEnum.SIMPLE },
        ];
    }
    
    static setItemsTheadBaseDateHour( datePipe: DatePipe | undefined ): BaseColumnInterface[] {
        return [
            { title: 'Fecha y Hora', field: 'date', type: BaseItemEnum.SIMPLE, styleThead: 'min-width: 130px;', transform: { type: PipeEnum.DATE_HOUR, pipe: datePipe } },
        ];
    }

    static setItemsTheadBaseStatus(): BaseColumnInterface[] {
        return [
            { title: 'Estado', field: 'status', type: BaseItemEnum.TAG }
        ];
    }

    static setItemsTheadBaseOperator(): BaseColumnInterface[] {
        return [
            { title: 'Operador', field: 'operator', type: BaseItemEnum.SIMPLE }
        ];
    }

    static setItemsTheadBaseLocation(): BaseColumnInterface[] {
        return [
            { title: 'Ubicación', field: 'locationSafeHtml', type: BaseItemEnum.LINK }
        ];
    }

    static setItemsTheadBaseComment(): BaseColumnInterface[] {
        return [
            { title: 'Comentario', field: 'comments', type: BaseItemEnum.SIMPLE }
        ];
    }
    /*  */

    /* Lists */
    /*  */

    /* Constants */
    static setBaseGlobalTitle(): string {
        return 'RG Group';
    }

    static setInitialPage(): string {
        return 'Inicio';
    }

    static setPageSizeIndex(): number { 
        //Index of setPageSizeOptions
        return 4;
    }

    static setPageSizeOptions(): number[] { 
        return [5, 10, 20, 50, 100];
    }

    static setClassTruncateText(): string {
        return 'truncate break-words whitespace-nowrap overflow-hidden text-ellipsis max-w-full';
    }
    /*  */

    /* Functions */
    /*  */
}